import React from 'react';
import {useNavigate} from 'react-router-dom';

import AppAnimateGroup from '../../../@crema/core/AppAnimateGroup';
import {Button} from 'antd';
import '../index.style.less';
import AppPageMetadata from '../../../@crema/core/AppPageMetadata';
import {ReactComponent as Logo} from '../../../assets/icon/maintenance.svg';
import {useTranslation} from 'react-i18next';

const Maintenance = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();

  const onGoBackToHome = () => {
    navigate(-1);
  };

  return (
    <AppAnimateGroup type='bottom'>
      <AppPageMetadata title='Maintenance' />
      <div className='error-container' key='a'>
        <div className='error-img-lg'>
          <Logo />
        </div>
        <div className='error-content error-content-lg'>
          <h3>{t('int-maintainance-msg-1')}</h3>
          <div className='error-para'>
            <p className='mb-0'>{t('int-maintainance-msg-2')}</p>
          </div>
          <Button type='primary' className='error-btn' onClick={onGoBackToHome}>
            {t('error-takeMeToHome')}
          </Button>
        </div>
      </div>
    </AppAnimateGroup>
  );
};

export default Maintenance;
